/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Not_Found_BodyInputs */

const en_apartment_not_found_body = /** @type {(inputs: Apartment_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This apartment isn't available. It may have been removed.`)
};

/**
* | output |
* | --- |
* | "This apartment isn't available. It may have been removed." |
*
* @param {Apartment_Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_not_found_body = /** @type {((inputs?: Apartment_Not_Found_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Not_Found_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_not_found_body(inputs)
});